// Storing the color constants in a typescript approved way.
export const defaultFontColor = "#000000";
export const immersightBlue = "#009fe3";
export const immersightBlueLighter1 = "rgb(0, 179, 247)";
export const immersightBlueLighter2 = "rgb(0, 199, 255)";
export const immersightBlueLighter3 = "rgb(0, 219, 255)";
export const immersightBlueDarker1 = "rgb(0, 139, 207)";
export const immersightBlueDarker2 = "rgb(0, 119, 187)";
export const immersightBlueDarker3 = "rgb(0, 89, 157)";
export const immersightBlue75 = "rgba(0, 159, 227, .75)";
export const immersightBlue50 = "rgba(0, 159, 227, .50)";
export const immersightBlue25 = "rgba(0, 159, 227, .25)";
export const immersightBlue10 = "rgba(0, 159, 227, .10)";
export const immersightButton = immersightBlue;
export const immersightGrey = "#9b9b9b";
export const immersightGrey75 = "rgba(155, 155, 155, .75)";
export const immersightGrey50 = "rgba(155, 155, 155, .50)";
export const immersightGrey25 = "rgba(155, 155, 155, .25)";
export const immersightGrey10 = "rgba(155, 155, 155, .10)";
export const immersightGreyLighter1 = "rgb(175, 175, 175)";
export const immersightGreyLighter2 = "rgb(195, 195, 195)";
export const immersightGreyLighter3 = "rgb(215, 215, 215)";
export const immersightGreyLighter1opa25 = "rgba(175, 175, 175, .25)";
export const immersightGreyLighter1opa50 = "rgba(175, 175, 175, .50)";
export const immersightGreyLighter1opa75 = "rgba(175, 175, 175, .75)";
export const immersightGreyLighter2opa25 = "rgba(195, 195, 195, .25)";
export const immersightGreyLighter2opa50 = "rgba(195, 195, 195, .50)";
export const immersightGreyLighter2opa75 = "rgba(195, 195, 195, .75)";
export const immersightGreyLighter3opa25 = "rgba(215, 215, 215, .25)";
export const immersightGreyLighter3opa50 = "rgba(215, 215, 215, .50)";
export const immersightGreyLighter3opa75 = "rgba(215, 215, 215, .75)";
export const primaryIconActive = immersightBlue;
export const primaryIconInactive = "#464646";
export const primaryIconClose = "#707070";
export const primaryIconCloseHover = "#666666";
export const secondaryIconActive = immersightBlue;
export const secondaryIconInactive = "#464646";
export const secondaryIconHover = immersightGreyLighter3opa25;
export const secondaryIconClose = "rgba(123, 123, 123, .8)";
export const inputBackground = "#dedede";
export const inputText = defaultFontColor;
export const inputBackgroundHover = "#acacac";
export const boxGrey = "rgb(111, 111, 111)";
export const deleteButton = "red";
export const logoutBackground = "#eeeeee";
export const defaultTextColor = "#000000";
export const imageListItemBackground = "#f7f7f7";
export const logoutText = defaultFontColor;
export const defaultBoxWithTextBackgroundColor = "#f7f8f8";
export const numberInputButtonStateColor1 = "#f7f7f7";
export const numberInputButtonStateColor2 = "#e7e7e7";
export const numberInputButtonStateColor3 = "#d7d7d7";
